import _defineProperty from "/home/runner/work/ecomm-blog-tng/ecomm-blog-tng/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { combine, isEmptyObject, display, createEventRateLimiter, isExperimentalFeatureEnabled, ExperimentalFeature, DISCARDED } from '@datadog/browser-core';
import { RumEventType } from '../rawRumEvent.types';
import { limitModification } from './limitModification';
var VIEW_MODIFIABLE_FIELD_PATHS = {
  'view.name': 'string',
  'view.url': 'string',
  'view.referrer': 'string'
};
var USER_CUSTOMIZABLE_FIELD_PATHS = {
  context: 'object'
};
var ROOT_MODIFIABLE_FIELD_PATHS = {
  service: 'string',
  version: 'string'
};
var modifiableFieldPathsByEvent;
export function startRumAssembly(configuration, lifeCycle, hooks, reportError) {
  modifiableFieldPathsByEvent = _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, RumEventType.VIEW, _objectSpread(_objectSpread(_objectSpread({
    'view.performance.lcp.resource_url': 'string'
  }, USER_CUSTOMIZABLE_FIELD_PATHS), VIEW_MODIFIABLE_FIELD_PATHS), ROOT_MODIFIABLE_FIELD_PATHS)), RumEventType.ERROR, _objectSpread(_objectSpread(_objectSpread({
    'error.message': 'string',
    'error.stack': 'string',
    'error.resource.url': 'string',
    'error.fingerprint': 'string'
  }, USER_CUSTOMIZABLE_FIELD_PATHS), VIEW_MODIFIABLE_FIELD_PATHS), ROOT_MODIFIABLE_FIELD_PATHS)), RumEventType.RESOURCE, _objectSpread(_objectSpread(_objectSpread(_objectSpread({
    'resource.url': 'string'
  }, isExperimentalFeatureEnabled(ExperimentalFeature.WRITABLE_RESOURCE_GRAPHQL) ? {
    'resource.graphql': 'object'
  } : {}), USER_CUSTOMIZABLE_FIELD_PATHS), VIEW_MODIFIABLE_FIELD_PATHS), ROOT_MODIFIABLE_FIELD_PATHS)), RumEventType.ACTION, _objectSpread(_objectSpread(_objectSpread({
    'action.target.name': 'string'
  }, USER_CUSTOMIZABLE_FIELD_PATHS), VIEW_MODIFIABLE_FIELD_PATHS), ROOT_MODIFIABLE_FIELD_PATHS)), RumEventType.LONG_TASK, _objectSpread(_objectSpread({
    'long_task.scripts[].source_url': 'string',
    'long_task.scripts[].invoker': 'string'
  }, USER_CUSTOMIZABLE_FIELD_PATHS), VIEW_MODIFIABLE_FIELD_PATHS)), RumEventType.VITAL, _objectSpread(_objectSpread({}, USER_CUSTOMIZABLE_FIELD_PATHS), VIEW_MODIFIABLE_FIELD_PATHS));
  var eventRateLimiters = _defineProperty(_defineProperty(_defineProperty({}, RumEventType.ERROR, createEventRateLimiter(RumEventType.ERROR, configuration.eventRateLimiterThreshold, reportError)), RumEventType.ACTION, createEventRateLimiter(RumEventType.ACTION, configuration.eventRateLimiterThreshold, reportError)), RumEventType.VITAL, createEventRateLimiter(RumEventType.VITAL, configuration.eventRateLimiterThreshold, reportError));
  lifeCycle.subscribe(12 /* LifeCycleEventType.RAW_RUM_EVENT_COLLECTED */, function (_ref) {
    var startTime = _ref.startTime,
      duration = _ref.duration,
      rawRumEvent = _ref.rawRumEvent,
      domainContext = _ref.domainContext,
      customerContext = _ref.customerContext;
    var defaultRumEventAttributes = hooks.triggerHook(0 /* HookNames.Assemble */, {
      eventType: rawRumEvent.type,
      startTime: startTime,
      duration: duration
    });
    if (defaultRumEventAttributes === DISCARDED) {
      return;
    }
    var serverRumEvent = combine(defaultRumEventAttributes, {
      context: customerContext
    }, rawRumEvent);
    if (shouldSend(serverRumEvent, configuration.beforeSend, domainContext, eventRateLimiters)) {
      if (isEmptyObject(serverRumEvent.context)) {
        delete serverRumEvent.context;
      }
      lifeCycle.notify(13 /* LifeCycleEventType.RUM_EVENT_COLLECTED */, serverRumEvent);
    }
  });
}
function shouldSend(event, beforeSend, domainContext, eventRateLimiters) {
  var _a;
  if (beforeSend) {
    var result = limitModification(event, modifiableFieldPathsByEvent[event.type], function (event) {
      return beforeSend(event, domainContext);
    });
    if (result === false && event.type !== RumEventType.VIEW) {
      return false;
    }
    if (result === false) {
      display.warn("Can't dismiss view events using beforeSend!");
    }
  }
  var rateLimitReached = (_a = eventRateLimiters[event.type]) === null || _a === void 0 ? void 0 : _a.isLimitReached();
  return !rateLimitReached;
}